<template>
	<ChipButton
		:active="active"
		:noBorders="noBorders"
		class="toggle-button"
		:class="{ 'toggle-button--negative': negative }"
	>
		<button
			class="toggle-button__content"
			:disabled="disabled"
			:class="{ 'toggle-button__content--disabled': disabled }"
			@click="$emit('click', $event)"
		>
			<span v-if="icon">
				<FontAwesomeIcon
					class="toggle-button__content-icon"
					:class="{
						'toggle-button__content-icon--faded': !active && !negative,
					}"
					:icon="ICONS[icon]"
				/>&nbsp;
			</span>
			<slot></slot>
		</button>
	</ChipButton>
</template>

<script setup lang="ts">
import ChipButton from '@/ui-components/ChipButton.vue';
import { faMinusCircle, faCheck } from '@fortawesome/free-solid-svg-icons';
import { jwCheckIcon } from '@/plugins/global-fontawesome';

const ICONS = {
	'minus-circle': faMinusCircle,
	'jw-check-icon': jwCheckIcon,
	check: faCheck,
};

withDefaults(
	defineProps<{
		active?: boolean;
		negative?: boolean;
		icon?: 'minus-circle' | 'jw-check-icon' | 'check';
		noBorders?: boolean;
		disabled?: boolean;
	}>(),
	{
		active: false,
		negative: false,
		noBorders: false,
		disabled: false,
	}
);

defineEmits<{
	(e: 'click', event: MouseEvent): void;
}>();
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';
@import '~@/styles/rtl-support-mixins.scss';

.toggle-button {
	margin: 0 0 4px;
	margin-inline-end: 10px;

	&__content {
		background: none;
		border: none;
		outline: none;
		cursor: pointer;

		&-icon {
			opacity: 1;

			&--faded {
				opacity: 0.2;
			}
		}

		&--disabled {
			cursor: default;
			opacity: 0.5;
		}
	}

	&--negative {
		background-color: $jw-color-black;

		button {
			color: $jw-color-white !important;
		}
	}
}
</style>
